import styled from "styled-components";

export const Container = styled.div`
  position: absolute;
  text-align: center;
  margin: 130px auto auto 400px;
`;

export const H2 = styled.h2`
  position: relative;
  padding: 10px;
  font-size: 28px;
  font-weight: 800;
  color: #fff;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-top: 0px;
  margin-bottom: 0px;
`;
export const Parghraph = styled.p`
  font-size: 14px;
  line-height: 25px;
  color: #fff;
  width: 520px;
  margin-top: 5px;
`;
export const Image = styled.img`
  position: relative;
  margin: 20px auto;
  vertical-align: middle;
  text-align: center;
  margin-top: 5px;
`;
export const Span = styled.span`
  font-style: normal;
  color: #ed563b;
`;
